"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const constants_1 = require("@dzambalaorg/constants");
const types_1 = require("@framework/types");
exports.validationSchema = (0, yup_1.object)().shape({
    owner: yup_rules_eth_1.addressValidationSchema,
    startTimestamp: (0, yup_1.string)()
        .matches(constants_1.reISO8601, "form.validations.patternMismatch")
        .required("form.validations.valueMissing"),
    cliffInMonth: (0, yup_1.number)()
        .typeError("form.validations.badInput")
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
    monthlyRelease: yup_rules_1.currencyValidationSchema
        .max(10000, "form.validations.rangeOverflow")
        .min(1, "form.validations.rangeUnderflow"),
    contractTemplate: (0, yup_1.mixed)()
        .oneOf(Object.values(types_1.VestingContractTemplates))
        .required("form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map